import { injectable } from 'inversify';
import { computed } from 'mobx';
import { MembershipNameType } from 'src/api/model/membershipNameType';

import { HomeStore } from '../../core/stores/home.store';
import { ClientDataStore } from './client-data.store';

@injectable()
export class MembershipNameTypeStore {
    @computed get name(): string | undefined {
        switch (this.isNameMembership) {
            case true:
                return 'Membership';
            case false:
                return 'Contract';
            default:
                return undefined;
        }
    }

    @computed get namePlural(): string | undefined {
        switch (this.isNameMembership) {
            case true:
                return 'Memberships';
            case false:
                return 'Contracts';
            default:
                return undefined;
        }
    }

    @computed get membershipsRoute() {
        return this.clientDataStore.isLoggedIn &&
            this.homeStore.homeData &&
            this.homeStore.homeData.membershipsEnabled
            ? this.homeStore.homeData.membershipNameType === MembershipNameType.NUMBER_0
                ? '/memberships'
                : '/contracts'
            : '/memberships/not-found';
    }

    @computed get viewPlural(): string | undefined {
        switch (this.isNameMembership) {
            case true:
                return 'View memberships';
            case false:
                return 'View contracts';
            default:
                return undefined;
        }
    }

    @computed private get isNameMembership(): boolean | undefined {
        const homeData = this.homeStore.homeData;
        if (!homeData) {
            return;
        }
        return homeData.membershipNameType === MembershipNameType.NUMBER_0;
    }

    constructor(private homeStore: HomeStore, private clientDataStore: ClientDataStore) {}
}
